<template>
<div>
  <b-card header='Fishbowl Payments' class='mt-2' v-if=show>
    <b-alert show variant=warning class='my-1' v-if='realPayments.length > 0'>
      IT will need to modify this order before you can make any changes
    </b-alert>

    <div class='my-1' v-if="transactionsToImport.length > 0">
      <div v-if=itAccess>
        <b-btn block v-for='transaction in transactionsToImport' :key="getToken(transaction)" @click="importTransaction(transaction)" variant=warning>
          <i class="fas fa-fw fa-user-lock"></i>
          Import <data-merger :dict=transaction.amount formatter=formatDollars title="Payment Amount" /> <data-merger :dict=transaction.method title="Payment Method" /> <data-merger :dict=transaction.displayNumber title="Payment Token" />
        </b-btn>
      </div>
      <div v-else>
        Manually importing payments is restricted. Please ask IT if you need to do this!
      </div>
    </div>

    <div v-for='payment in realPayments' class='my-1' :key='payment.tenderId'>
      {{payment.amount.fishbowl | formatDollars}} {{payment.method.fishbowl}}
    </div>
  </b-card>

  <b-modal
    id=statusModal ref=statusModalRef
    centered
    :no-close-on-backdrop=waitingOnChamp
    :no-close-on-esc=waitingOnChamp
    :hide-header-close="true"
    @hidden="reloadPage()"
  >
    <div class="d-block text-center" v-html="this.loadingMessage">
    </div>
    <div slot="modal-footer" class="w-100">
      <b-button variant=primary :disabled=waitingOnChamp @click="hideModal()">
        OK
      </b-button>
    </div>
  </b-modal>
</div>
</template>

<script>
import axios from 'axios'
import NiceDate from '../../utility/NiceDate'
import utility from '../../../helpers/utility'
import orderMerge from '../../../services/orderMerge'
import { mapGetters } from 'vuex'
import DataMerger from '../../utility/DataMerger.vue'

const BASE_API = process.env.VUE_API_ROOT

export default {
  components: {
    NiceDate,
    DataMerger,
  },
  data() {
    return {
      waitingOnChamp: false,
      loadingMessage: '',
    }
  },
  props: {
    order: { type: Object, required: true },
  },
  computed: {
    ...mapGetters({
      canAccess: 'canAccess',
    }),
    itAccess() {
      return this.$store.getters.canAccess('it-staff')
    },
    show() {
      return true
    },
    realPayments() {
      return this.order.payments.filter(x => !!x.method.fishbowl && x.method.fishbowl !== "PurchaseOrder")
    },
    transactionsToImport() {
      return this.order.payments.filter(x =>
        !!x.id && !x.amount.fishbowl && x.amount[this.order.websiteName] > 0
      )
    },
  },
  methods: {
    hideModal() {
      this.$refs.statusModalRef.hide()
    },
    reloadPage() {
      window.location.reload()
    },
    getToken(row) {
      return orderMerge.mergeField(row.token)
    },
    importTransaction(transaction) {
      this.$refs.statusModalRef.show()
      this.waitingOnChamp = true

      let method = orderMerge.mergeField(transaction.method);
      if (method === "PDV") method = 'Product Discount Voucher (PDV)'

      let body = {
        id: orderMerge.mergeField(transaction.id),
        token: orderMerge.mergeField(transaction.id),
        amount: orderMerge.mergeField(transaction.amount),
        method
      }
      axios({
        method: 'POST',
        headers: { 'Content-Type': 'text/plain' },
        url: `${BASE_API}/champ/import-transaction/${this.order.num}`,
        data: body
      }).then(response => {
        this.loadingMessage = 'Payment Submitted, waiting for a response...'
        this.infoAuditLog('Imported payment transaction', "", this.order.num, body, null)
        utility.waitResponse(response.data, (() => {
          this.waitingOnChamp = false
          this.loadingMessage = 'Success!'
        }), (response => {
          this.waitingOnChamp = false
          this.loadingMessage = response.Response
        }), (() => {
          this.waitingOnChamp = false
          this.loadingMessage = 'Error (DO NOT RESUBMIT): Getting response failed. See console for full message.'
        }));
      }).catch(error => {
        console.error(error)
        this.loadingMessage = 'Submit Failed. See console for full message...', 'Close', 'danger';
        this.waitingOnChamp = false;
      })
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/sales-order/view-order-2/FishbowlPayments.vue